import React from "react";
import { DateDisplay } from "../DateDisplay";
import { InvoiceHistoryEntry } from "../../models/Invoice";
import { Typography, List, ListItem } from "@material-ui/core";
import colors from "../../constants/colors";

interface InvoiceViewHistoryDialogProps {
	//The list of invoice history items to be displayed.
	historyList: InvoiceHistoryEntry[];
}

/**
 * This component is used for generating the dialog content to display
 * the invoice history list in the invoice details page dialog.
 * @param props
 */
export const InvoiceViewHistoryDialog = (props: InvoiceViewHistoryDialogProps) => {
	return (
		<div
			style={{
				margin: 5,
				overflow: "auto",
			}}
			data-testid="invoice-history-dialog-list"
		>
			<List>
				{props.historyList.map((historyEntry) => (
					<ListItem key={historyEntry.date} data-testid="invoice-history-entry-list-item">
						<div
							style={{
								backgroundColor: colors.gray100,
								boxShadow: "-1px 1px 1px gray",
								border: "1px solid",
								borderColor: colors.gray300,
								borderRadius: 5,
								minWidth: 700,
								minHeight: 50,
								padding: 5,
							}}
						>
							<div style={{ float: "right" }}>
								<DateDisplay fontSize={12} date={historyEntry.date}></DateDisplay>
							</div>
							<div>
								<Typography>{historyEntry.note}</Typography>
							</div>
						</div>
					</ListItem>
				))}
			</List>
		</div>
	);
};
